import React from 'react'
import { Link } from 'react-router-dom'

// FIXME: @shervin: not sure how happy i am with duplicating the routes here..
// Cant really think of a better way though, maybe some way of hooking into
// react router or the history stuff would be able to handle this.
const VALID_PATHS = ['/category/', '/tags/', '/attributes/', '/search']

// This component given a path will either return a link that will do a
// full page refresh, or a SPA history pushState update
const CategoryLink = props => {
  const { to } = props
  const validPath = VALID_PATHS.some(path => to.indexOf(path) === 0)

  if (validPath) {
    return <Link {...props} />
  } else {
    return (
      <a {...props} href={to} target="_self">
        {props.children}
      </a>
    )
  }
}

export default CategoryLink



// WEBPACK FOOTER //
// ./client/components/categoriesMenu/categoryLink.js